import {Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
    selector: 'radio',
    templateUrl: './input.radio.component.html'
})
export class RadioComponent implements OnInit, OnChanges {
    /**
     * Labeltextkey
     */
    @Input() label: string;

    /**
     * name of the radio
     */
    @Input() name: string;

    /**
     * value of the radio
     */
    @Input() value: string;

    /**
     * required field or not
     */
    @Input() required: boolean;

    /**
     * toggle if the input should be disabled
     */
    @Input() disabled = false;

    /**
     * Classnamen (cssclass)
     * @type {string}
     */
    @Input() class = '';

    /**
     * Should the radio be preset or not
     * @type {boolean}
     */
    @Input() set = false;

    /**
     * Should the label has an arrow to the right or not?
     * @type {boolean}
     */
    @Input() arrow = false;

    /**
     * Model for databinding
     */
    @Input() model: any;

    /**
     * Form for validation
     */
    @Input() form: FormGroup;

    /**
     * Icon that is shown inside the label
     * @type {any}
     */
    @Input() icon: string = null;

    /**
     * SVG Icons that is shown inside the label
     */
    @Input() svgIcon: string = null;

    /**
     * show recommendation
     */
    @Input() hasRecommendation = false;

    /**
     * recommendation text label
     */
    @Input() recommendationLabel: string;

    /**
     * if of another element that is controlled by this radio
     */
    @Input() ariaControls: string = null;

    /**
     * Id of the element that describes this radio
     */
    @Input() ariaDescribedBy: string = null;

    /**
     * if the toggle is set, every modelchange is set immediately
     */
    @Input() instantChange = true;

    /**
     * two way databinding for changing the model
     * @type {EventEmitter}
     */
    @Output() modelChange: EventEmitter<any> = new EventEmitter();

    /**
     * calculated id of the element
     * @type {string}
     */
    id = '';

    /**
     * title attribute for the label
     */
    labelTitle: string;

    /**
     * Function is called when initializing the component
     */
    ngOnInit(): void {
        if (this.form.contains(this.name) === false) {
            // fallback for the case that the formcontroll is missing
            this.form.addControl(this.name, new FormControl());
        }

        // in some cases the preset (checked) attribut did not worked, so we set tha form control value here if this item is selected
        // tslint:disable-next-line:triple-equals
        if (this.model == this.value) {
            this.form.controls[this.name].setValue(this.value);
        }

        this.id = this.name + '_' + this.value;
        this.id = this.id.replace(/ /, "_").replace(/"/, '').replace(/'/, '');

        // put special class if the element is presetted
        if (this.set === true) {
            if (this.class?.length > 0) {
                this.class += " ";
            }
            else {
              this.class = '';
            }
            this.class += "set";
        }

        // put special class if the element has an arrow
        if (this.arrow === true) {
            if (this.class.length > 0) {
                this.class += " ";
            }
            this.class += "arrow";
        }

        // set initial title
        this.updateTitle();
    }

    /**
     * Update the title with the label value without html
     */
    updateTitle(): void {
        const div = document.createElement("div");
        div.innerHTML = this.label?.replace(/<br ?\/?>/, " ")?? "";
        this.labelTitle = div.textContent || div.innerText || "";
    }

    /**
     * @inheritDoc
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty('label') && changes.label.firstChange === false) {
            this.updateTitle();
        }
    }

    /**
     * Function to update the model and inform the parent Component about it.
     * We can not use databinding here because it will not work together with
     * @param newValue
     * @param event
     */
    updateModel(newValue: string, event: Event) {
        event.preventDefault();
        this.model = newValue;
        this.modelChange.emit(newValue);
    }
}
